import type { MouseEventHandler } from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';
import { SlotProps, styled } from '@mui/material';
import { spacing, SpacingProps } from '@mui/system';

interface IProps extends SpacingProps {
  checked: boolean;
  small?: boolean;
  disableRipple?: boolean;
  indeterminate?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  color?: CommonPropsAndTypes.LimitedColorType;
  disabled?: boolean;
  backgroundColorWhite?: boolean;
  dataTest?: string;
}

/**
Checkbox utan label 
 */
export const EDSimpleCheckboxBase: React.FC<
  React.PropsWithChildren<IProps & { className?: string }>
> = props => {
  return (
    <MuiCheckbox
      sx={[
        Boolean(props.small) && {
          width: '16px',
          height: '16px',
          boxSizing: 'content-box',
        },
        Boolean(props.backgroundColorWhite) &&
          props.checked && {
            '&.Mui-checked': {
              color: 'common.white',
            },
          },
        Boolean(props.backgroundColorWhite) &&
          !props.checked && {
            color: 'primary.main',
          },
      ]}
      slotProps={{
        input: {
          'data-testid': props.dataTest,
        } as SlotProps<'input', {}, 'MuiCheckbox'>,
      }}
      className={props.className}
      checked={!!props.checked}
      onChange={props.onChange}
      disableRipple={props.disableRipple}
      indeterminate={props.indeterminate}
      onClick={props.onClick}
      color={props.color}
      disabled={props.disabled}
      data-test={props.dataTest}
    />
  );
};

export const EDSimpleCheckbox: React.FC<React.PropsWithChildren<IProps>> =
  styled(EDSimpleCheckboxBase, {
    name: 'EDSimpleCheckbox',
  })(spacing);

export default EDSimpleCheckbox;
